export function CheckmarkSuccess(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.25 8.76437L5.78125 10.9375C5.83933 11.0243 5.9173 11.0959 6.00865 11.1464C6.10001 11.197 6.20212 11.225 6.30648 11.2281C6.41084 11.2312 6.51444 11.2094 6.60865 11.1644C6.70286 11.1194 6.78497 11.0525 6.84812 10.9694L11.75 4.7675M0.96875 7.99937C0.96875 8.92273 1.15062 9.83705 1.50397 10.6901C1.85733 11.5432 2.37524 12.3183 3.02816 12.9712C3.68107 13.6241 4.45619 14.142 5.30926 14.4954C6.16233 14.8488 7.07664 15.0306 8 15.0306C8.92336 15.0306 9.83767 14.8488 10.6907 14.4954C11.5438 14.142 12.3189 13.6241 12.9718 12.9712C13.6248 12.3183 14.1427 11.5432 14.496 10.6901C14.8494 9.83705 15.0313 8.92273 15.0312 7.99937C15.0313 7.07602 14.8494 6.1617 14.496 5.30863C14.1427 4.45556 13.6248 3.68044 12.9718 3.02753C12.3189 2.37462 11.5438 1.8567 10.6907 1.50335C9.83767 1.14999 8.92336 0.968124 8 0.968124C7.07664 0.968124 6.16233 1.14999 5.30926 1.50335C4.45619 1.8567 3.68107 2.37462 3.02816 3.02753C2.37524 3.68044 1.85733 4.45556 1.50397 5.30863C1.15062 6.1617 0.96875 7.07602 0.96875 7.99937Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
